export default "__VITE_ASSET__BoTmy9fX__"